import {
  VisuallyHidden,
  OutlineCircleQuestionIcon,
} from '@frontend/components';

import HeaderIconButton from 'components/HeaderIconButton/HeaderIconButton';

const HelpModeTrigger = ({ className, onClick }) => (
  <HeaderIconButton
    color="feature.onInteraction"
    className={className}
    onClick={onClick}
  >
    <OutlineCircleQuestionIcon size={4} />
    <VisuallyHidden>Open Help Mode</VisuallyHidden>
  </HeaderIconButton>
);

export default HelpModeTrigger;
